import React, { useState, useEffect } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { register } from '../../actions/auth';
import { checkEmail } from '../../actions/user';
import { toast } from 'react-toastify';
import Loader from '../loader/Loader';
import PropTypes from 'prop-types';

// Images
import color_logo from '../../img/color_logo.png';
import ecom_logo_color from '../../img/ecom_logo_color.png';

// CSS
import '../../css/onBoarding/register.css';
import '../../css/onBoarding/login.css';

const Register = ({ register, checkEmail, isOtpVerification }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    mobile: '',
  });
  const [loading, setLoading] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isNewEmail, setIsNewEmail] = useState(false);

  // Destructure formData
  const { name, email, password, mobile } = formData;

  const onChange = (e) =>
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  const onChangeMobile = (e) => {
    const { value } = e.target;

    // Check if the entered value is numeric
    if (/^\d*$/.test(value) || value === '') {
      setFormData({
        ...formData,
        mobile: value,
      });
    }
  };

  const handleTermsCheckboxChange = () => {
    setTermsAccepted(!termsAccepted);
  };

  const onContinue = async () => {
    if (!email) {
      toast.error('Please enter an email address.');
      return;
    }

    try {
      const response = await checkEmail(email); // Pass the email to the action
      console.log('res', response);
      if (response.status === 200 && response.data.user === 0) {
        setIsNewEmail(true); // Email is new
      } else {
        setIsNewEmail(false); // Email exists
        toast.error('This email is already registered.');
      }
    } catch (error) {
      console.error('Error checking email:', error);
      toast.error('Failed to verify email. Please try again.');
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    // console.log('Registered values', formData);

    // Check if the terms and conditions checkbox is checked
    // if (!termsAccepted) {
    //   toast.error('Please accept the Terms and Conditions.');
    //   return;
    // }

    setLoading(true);
    register({
      name,
      email,
      password,
      mobile,
    })
      .then((e) => {
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
    // console.log('Success');
  };

  // Redirect if logged in
  if (localStorage.getItem('token')) {
    return <Navigate to='/login' replace={true} />;
  }

  return (
    <div className='flex flex-col items-center justify-center'>
      {/* Logo Section */}
      <div className=''>
        <Link to='/overview'>
          <img
            src={ecom_logo_color}
            alt='Logo'
            className='color-logo-register w-24 h-24'
          />
        </Link>
      </div>

      {/* Heading Section */}
      <div className='text-center'>
        <h2 className='form-heading'>Create an account</h2>
      </div>

      {/* Form Section */}
      <form className='w-80' onSubmit={(e) => onSubmit(e)} method='POST'>
        <div className=''>
          <input
            id='email-address'
            name='email'
            type='email'
            value={email}
            onChange={(e) => onChange(e)}
            autoComplete='email'
            required
            placeholder='Email'
            className='register-input-field bg-gray-50 w-full p-2'
          />
        </div>

        {isNewEmail && (
          <>
            <div className=''>
              <input
                id='password'
                name='password'
                type='password'
                value={password}
                onChange={(e) => onChange(e)}
                autoComplete='current-password'
                required
                placeholder='Password'
                className='password-input bg-gray-50 w-full p-2'
              />
            </div>
            <div className=''>
              <input
                id='name'
                name='name'
                type='text'
                value={name}
                onChange={(e) => onChange(e)}
                autoComplete='name'
                required
                maxLength='40'
                placeholder='Full Name'
                className='register-input-field bg-gray-50 w-full p-2'
              />
            </div>
            <div className=''>
              <input
                id='mobile'
                name='mobile'
                type='tel'
                value={mobile}
                onChange={onChangeMobile}
                autoComplete='current-mobile'
                pattern='[0-9]{10}'
                title='Please enter a 10-digit numeric mobile number.'
                inputMode='numeric'
                minLength={10}
                maxLength={10}
                required
                placeholder='Mobile Number'
                className='register-input-field bg-gray-50 w-full p-2'
              />
            </div>
          </>
        )}

        {isNewEmail ? (
          <button type='submit' className='register-button w-full py-2'>
            Sign Up
          </button>
        ) : (
          <button
            type='button'
            onClick={onContinue}
            className='continue-button w-full py-2'
          >
            Continue
          </button>
        )}
      </form>

      {/* Login Section */}
      <div className=''>
        <p className='already-account'>
          Already have an account?{' '}
          <Link to='/login' className='login-link'>
            Login
          </Link>
        </p>
      </div>
    </div>
  );
};

Register.propTypes = {
  // setAlert: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  // isAuthenticated: PropTypes.bool.isRequired,
  isOtpVerification: PropTypes.bool.isRequired,
  checkEmail: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  // isAuthenticated: state.auth.isAuthenticated,
  isOtpVerification: state.auth.isOtpVerification,
});

export default connect(mapStateToProps, { register, checkEmail })(Register);
